const ibe = {
  loadDates(jnr) {
    showLoadIcon(true);
    $('.js-block-dates').load('/ibe/index/load-dates/jnr/' + jnr, function () {
      hideLoadIcon();

      let startDate = '';
      $('.css-block-date').each(function (index) {
        startDate = $(this).data('end-date');
      });

      if (startDate.length === 10) {
        ibe.loadNextDate(startDate);
      }
    });
  },
  loadNextDate(startDate) {

    let url = '/ibe/index/load-more-dates/jnr/' + jnr;

    if (startDate.length === 10) {
      url = url + '/start/' + startDate;
    }
    $('.js-dates-list').append('<div class="css-loader css-center"></div>');
    $.ajax({
      url: url,
      type: 'GET',
      success: function (data) {

        if (data.length > 0) {
          $('.js-dates-list > div.css-loader').remove();
          $('.js-dates-list').append(data);
          let startDate = '';
          $(data).each(function (index) {
            if ($(this).hasClass('css-block-date')) {
              startDate = $(this).data('end-date');
            }
          });

          if (startDate.length === 10) {
            //$('.js-dates-list').append('<div class="css-loader css-center"></div>');
            ibe.loadNextDate(startDate);
          }
        } else {
          hideLoadIcon();
          $('.js-dates-list > div.css-loader').remove();
        }
      }
    });
  },
  loadDateForm(jnr) {
    $('.js-block-select-date').load('/ibe/index/load-date-form/jnr/' + jnr, function () {
      hideLoadIcon();
    });
  },
  initDate(jnr, date) {
    $.ajax({
      url: '/ibe/index/init-date/jnr/' + jnr,
      type: 'POST',
      data: {date: date},
      success: function (data) {
        window.location.href = '/ibe/index/index/jnr/' + jnr;
      }
    });
  },
  loadHotelBlock(callback) {
    $('.js-block-hotels').load('/ibe/index/load-hotel-services/jnr/' + jnr, function () {
      hideLoadIcon();
      callback();
    });
  },
  loadCartBlock() {
    $('.js-block-cart').load('/ibe/shopping-cart/load-cart-block/jnr/' + jnr, function () {
      hideLoadIcon();
    });
  },

  loadTotalPriceBlock() {
    $('.js-block-total-price').load('/ibe/index/load-total-price-block/jnr/' + jnr, function () {
      hideLoadIcon();
    });
  },

  checkStartDate(date) {
    const availDays = JSON.parse($('#js-datepicker-start-days').val());

    // verfuegbare termine fuer datepicker:
    const availDaysDatepicker = [];

    for (let i = 0; i < availDays.length; i++) {
      const res = availDays[i][0].split('.');
      const myDate = new Date(res[2], res[1] - 1, res[0]);
      availDaysDatepicker[i] = myDate.toGMTString();
    }

    const formattedDate = date.toGMTString();
    if ($.inArray(formattedDate, availDaysDatepicker) === -1 && availDaysDatepicker.length > 0) {
      return [false, "", "unAvailable"];
    }
    return [true, "", "Verfügbar"];
  },

  checkEndDate(date) {

    const endDays = JSON.parse($('#js-datepicker-end-days').val());

    const endDaysDatepicker = [];
    for (let i = 0; i < endDays.length; i++) {
      const res = endDays[i][0].split('.');
      const myDate = new Date(res[2], res[1] - 1, res[0]);
      endDaysDatepicker[i] = myDate.toGMTString();
    }

    const formattedDate = date.toGMTString();
    if ($.inArray(formattedDate, endDaysDatepicker) === -1 && endDaysDatepicker.length > 0) {
      return [false, "", "unAvailable"];
    }
    return [true, "", "Verfügbar"];
  },
  updateDateForm() {
    $.ajax({
      url: '/ibe/index/load-date-form/jnr/' + jnr,
      type: 'POST',
      data: $('#select-date-form').serialize(),
      // xhrFields: {
      //   withCredentials: true
      // },
      success: function (data) {
        $('.js-block-select-date').html(data);
        hideLoadIcon();
      }
    });
  },
  updateHotel(key, action) {
    $.ajax({
      url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
      type: 'post',
      data: {key: key, action: action},
      success: function (data) {
        ibe.loadHotelBlock(function () {
          if (action === 'add') {
            ibe.hotel.showModalPartialRoom(key);
          }
        });
        ibe.loadCartBlock();
        ibe.loadTotalPriceBlock();

        hideLoadIcon();
      }
    });
  },
  showError(message) {
    const alert = '<div role="alert" class="center alert alert-dismissible alert-danger">\n' +
      '      <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
      '        <span aria-hidden="true">&times;</span>\n' +
      '      </button>\n' +
      '      <strong class="bold"><?= $type ?></strong>' + message + '</div>';
    $('#js-flash-alert-box').html(alert);
  },
  showSuccess(message) {
    const alert = '<div role="alert" class="center alert alert-dismissible alert-success">\n' +
      '      <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
      '        <span aria-hidden="true">&times;</span>\n' +
      '      </button>\n' +
      '      <strong class="bold"><?= $type ?></strong>' + message + '</div>';
    $('#js-flash-alert-box').html(alert);
  },
  showServiceLoader(button) {
    const icon = '<div class="css-loader-box"><div class="css-loader-image"></div></div>';
    const valueBox = button.parent().find('.quantity');
    valueBox.html(icon);
  },
  hotel: {
    updateFerryCabin(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadHotelBlock(function () {
          });
          ibe.loadCartBlock();
          ibe.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    showModalPartialRoom(key) {
      let button = $("i[data-service-key='" + key + "']");
      let modal = button.closest('.row').find('#modal-info-partial-room');
      if (modal !== undefined) {
        modal.modal('show');
      }
    }
  },

  arrival: {
    updateArrival(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.arrival.loadArrivalBlock();
          ibe.arrival.loadTransferBlock();
          ibe.arrival.loadSeatReservationBlock();
          ibe.arrival.loadRailAndFlyBlock();
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateFlightOffer(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.arrival.loadFlightOfferBlock();
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateSeatReservation(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.arrival.loadSeatReservationBlock();
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateTransfer(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.arrival.loadTransferBlockInner();
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },

    updateRailAndFly(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.arrival.loadRailAndFlyBlock();
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateOfferAirport(element) {
      const airport = element.val();
      const key = element.data('key');
      const fieldName = element.attr('name');
      $.ajax({
        url: '/ibe/service/update-offer-airport/jnr/' + jnr,
        type: 'post',
        data: {key: key, fieldName: fieldName, airport: airport},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          //ibe.arrival.loadFlightOfferBlock();
          hideLoadIcon();
        }
      });
    },
    updateSeatReservationMessage(element) {
      const message = element.val();
      const key = element.data('key');

      $.ajax({
        url: '/ibe/service/update-seat-reservation-message/jnr/' + jnr,
        type: 'post',
        data: {key: key, message: message},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.arrival.loadTotalPriceBlock();
          ibe.arrival.loadSeatReservationBlock();
          hideLoadIcon();
        }
      });
    },
    loadArrivalBlock() {
      $('.js-block-arrival').load('/ibe/service/load-arrival-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadFlightOfferBlock() {
      $('.js-block-flight-offer').load('/ibe/service/load-flight-offer-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadSeatReservationBlock() {
      $('.js-block-seat-reservation').load('/ibe/service/load-seat-reservation-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadTransferBlock() {
      $('.js-block-own-arrival-transfer').load('/ibe/service/load-own-arrival-transfers/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadTransferBlockInner() {
      $('#js-collapse-transfers').load('/ibe/service/load-own-arrival-transfers-inner-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },

    loadRailAndFlyBlock() {
      $('.js-block-rail-and-fly').load('/ibe/service/load-rail-and-fly/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadTotalPriceBlock() {
      $('.js-block-total-price').load('/ibe/service/load-total-price-block/jnr/' + jnr + '/additional/0', function () {
        hideLoadIcon();
      });
    },
  },

  additional: {
    loadAdditionalBlock() {
      $('.js-block-additional').load('/ibe/service/load-additional-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadTotalPriceBlock() {
      $('.js-block-total-price').load('/ibe/service/load-total-price-block/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadCateringBlock() {
      $('#js-collapse-catering').load('/ibe/service/load-catering/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadInsuranceBlock() {
      $('#js-collapse-insurance').load('/ibe/service/load-insurance/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadDocumentBlock() {
      $('#js-collapse-documents').load('/ibe/service/load-documents/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    // loadTransferBlock() {
    //   $('#js-collapse-transfers').load('/ibe/service/load-transfers/jnr/' + jnr, function () {
    //     hideLoadIcon();
    //   });
    // },
    loadStationBlock() {
      $('#js-collapse-stations').load('/ibe/service/load-stations/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadBikeBlock() {
      $('#js-collapse-bike-services').load('/ibe/service/load-bikes/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadExtraNightPreBlock() {
      $('#js-collapse-extra-night-pre').load('/ibe/service/load-extra-night-pre/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadExtraNightAfterBlock() {
      $('#js-collapse-extra-night-after').load('/ibe/service/load-extra-night-after/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadOtherBlock() {
      $('.js-content-block-other').load('/ibe/service/load-other/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadInnerOtherBlock() {
      $('#js-collapse-other').load('/ibe/service/load-other-inner-block/jnr/' + jnr + '', function () {
        hideLoadIcon();
      });
    },
    loadTransferRequiredBlock() {
      $('#js-collapse-transfers-required').load('/ibe/service/load-transfer-required/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    loadRentalCarBlock() {
      $('#js-collapse-rental-car-services').load('/ibe/service/load-rental-cars/jnr/' + jnr, function () {
        hideLoadIcon();
      });
    },
    updateCatering(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-catering-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadCateringBlock();
          hideLoadIcon();
        }
      });
    },

    updateInsurance(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-insurance-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.additional.loadInsuranceBlock();
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateInsuranceConfirm(checkbox) {
      let state = 0;
      if (checkbox.is(':checked')) {
        state = 1;
      }

      $.ajax({
        url: '/ibe/service/confirm-insurance/jnr/' + jnr,
        type: 'post',
        data: {state: state},
        success: function (data) {
          hideLoadIcon();
        }
      });
    },
    updateDocument(key, action) {
      $.ajax({
        url: '/ibe/service/update-document/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadDocumentBlock();
          ibe.additional.loadInsuranceBlock();
          hideLoadIcon();
        }
      });
    },
    updateBikeType(key, action) {
      $.ajax({
        url: '/ibe/service/update-bike/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadBikeBlock();
          ibe.additional.loadInsuranceBlock();
          hideLoadIcon();
        }
      });
    },
    updateExtraNight(key, action) {
      $.ajax({
        url: '/ibe/service/update-extra-night/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadExtraNightPreBlock();
          ibe.additional.loadExtraNightAfterBlock();
          ibe.additional.loadInsuranceBlock();
          ibe.additional.loadOtherBlock();
          hideLoadIcon();
        }
      });
    },
    updateStation(key, action) {
      $.ajax({
        url: '/ibe/service/update-station/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadStationBlock();
          ibe.additional.loadInsuranceBlock();
          hideLoadIcon();
        }
      });
    },
    updateOther(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.additional.loadInnerOtherBlock();
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadInsuranceBlock();
          hideLoadIcon();
        }
      });
    },
    updateTransfer(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.additional.loadTransferRequiredBlock();
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateRentalCar(key, action) {
      $.ajax({
        url: '/ibe/shopping-cart/update-service/jnr/' + jnr,
        type: 'post',
        data: {key: key, action: action},
        success: function (data) {
          ibe.additional.loadRentalCarBlock();
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          hideLoadIcon();
        }
      });
    },
    updateBikeSize(element) {
      const key = element.val();
      const bikeTypeKey = element.data('bike-type');
      const position = element.data('position');
      $.ajax({
        url: '/ibe/service/update-bike-size/jnr/' + jnr,
        type: 'post',
        data: {key: key, typeKey: bikeTypeKey, position: position},
        success: function (data) {
          ibe.loadCartBlock();
          ibe.additional.loadTotalPriceBlock();
          ibe.additional.loadBikeBlock();
          hideLoadIcon();
        }
      });
    },

  },
  traveller: {
    addVoucher(code) {
      $.ajax({
        method: "POST",
        url: "/ibe/traveller/add-voucher/jnr/" + jnr,
        data: {code: code},
        dataType: 'json',
        success: function (response) {

          if (response.status === 'OK') {
            ibe.showSuccess(response.msg);
          } else {
            ibe.showError(response.msg);
          }

          hideLoadIcon();
        }
      });
    },
    findCustomer() {
      let text = $('#searchCustomer').val();

      if (text.length > 2) {
        $.ajax({
          type: "POST",
          url: "/ibe/traveller/search-customer/jnr/" + jnr,
          data: {text: text},
          dataType: 'json',
          success: function (data) {
            const container = document.querySelector("#js-search-result");
            container.innerHTML = '';
            let max = data.length;
            if (max > 10) {
              // Limit
              max = 10;
            }

            let val;
            for (let i = 0; i < max; i++) {
              val = data[i];
              const div = document.createElement("div");
              div.setAttribute('class', 'item');
              div.setAttribute('data-nr', val.customer);
              let content = val.customer + '<br><b>' + val.nachname + ', ' + val.vorname + '</b>';
              content += '<br>' + val.email;
              content += '<br>' + val.strasse + ' | <b>' + val.plz + ' ' + val.ort + '</b>';
              div.innerHTML = content;
              container.appendChild(div);
            }

            $(container).show();
          }
        });
      }

    }


  },
  book: {
    deactivateButton() {
      let button = $('#book-button');
      button.hide();
    }
  }
};


$(function () {
  $('body').on('hide.bs.collapse', '.collapse', function () {
    //$(this).parent().removeClass('css-block-white');
    $(this).parent().find('.css-collapse-container-header .lineicon').removeClass('lineicon-Minus');
    $(this).parent().find('.css-collapse-container-header .lineicon').addClass('lineicon-Plus');
  });
  $('body').on('show.bs.collapse', '.collapse', function () {
    //$(this).parent().addClass('css-block-white');
    $(this).parent().find('.css-collapse-container-header .lineicon').removeClass('lineicon-Plus');
    $(this).parent().find('.css-collapse-container-header .lineicon').addClass('lineicon-Minus');

    const panel = $(this).closest('.css-collapse-container');
    $('html,body').animate({
      scrollTop: panel.offset().top
    }, 500);
  });


  $(document).on('click', '#js-search-result .item', function () {
    const nr = $(this).data('nr');
    $('#js-search-result').hide();

    showLoadIcon();

    $.ajax({
      type: "POST",
      url: "/ibe/traveller/select-customer/jnr/" + jnr,
      data: {nr: nr},
      success: function (data) {
        if (data === 'reload') {
          window.location.reload();
        } else {
          hideLoadIcon();
        }
      }
    });

  });

  $('body').on('focus', '.form-control', function () {
    $(this).prev('.input-group-addon').addClass('input-group-addon-focus');
    $(this).next('.input-group-addon').addClass('input-group-addon-focus');
    $(this).parent('.form-group').prev('.input-group-addon').addClass('input-group-addon-focus');
    $(this).parent('.form-group').next('.input-group-addon').addClass('input-group-addon-focus');
  });

  $('body').on('focusout', '.form-control', function () {
    $(this).prev('.input-group-addon').removeClass('input-group-addon-focus');
    $(this).next('.input-group-addon').removeClass('input-group-addon-focus');
    $(this).parent('.form-group').prev('.input-group-addon').removeClass('input-group-addon-focus');
    $(this).parent('.form-group').next('.input-group-addon').removeClass('input-group-addon-focus');
  });

  $('body').on('click', '.css-select-amount-button', function () {
    const button = $(this);
    if (button.attr('onclick') !== undefined) {
      ibe.showServiceLoader(button);
    }
  });

});